import { useEffect, useRef, useState } from "react";
import { Form } from "./Form";
import { Table } from "./Table";
import { Toast } from "primereact/toast";
import { IPurchaseOrder } from "../../models/PurchaseOrder";

interface IProps {
    byPrimeInvoice?: { singleData: any, open: boolean },
    isConsultant?: boolean,
    poID?: IPurchaseOrder,
}

export const SubVendorInvoices = (props: IProps) => {
    const [modal, setModal] = useState({ singleData: {}, recent: {}, open: false } as { singleData: any, recent: any, open: boolean });
    const [reload, setReload] = useState<boolean>(false);
    const toast = useRef<any>(null);

    const onHideModal = () => {
        setModal({ singleData: {}, recent: {}, open: false });
        setReload(prev => prev = !reload);
    };
    const onOpenModal = (data: any) => {
        if (props.byPrimeInvoice?.open) {
            setModal({ singleData: props.byPrimeInvoice.singleData, recent: {}, open: true });
        } else {
            setModal({ singleData: data, recent: {}, open: true });
        }
    };

    // useEffect(() => {
    //     if (props.byPrimeInvoice?.open) {
    //         setModal({ singleData: props.byPrimeInvoice.singleData, recent: {}, open: false });
    //     }
    // }, []);

    return (
        <>
            <Form open={modal.open} singleData={modal.singleData} recent={modal.recent} onHide={onHideModal} toast={toast} />
            <Table openForm={onOpenModal} toast={toast} open={modal.open} setModal={setModal} byPrimeInvoice={props.byPrimeInvoice} reload={reload} />
            <Toast ref={toast} />
        </>
    );
}